import axios from 'axios';
import { attachAcceptLanguage } from 'src/api/interceptors/attach-accept-language';
import { attachAccessToken } from 'src/api/interceptors/attach-access-token';
import { attachDirectoryTokenLockspace } from '../interceptors/attach-directory-token-lockspace';

const siteLockspaceApi = axios.create({
  baseURL: `${import.meta.env.VITE_LOCKSPACE_API_URL}/tenant-admin/v1/tenants`,
});

siteLockspaceApi.interceptors.request.use(attachAcceptLanguage);
siteLockspaceApi.interceptors.request.use(attachAccessToken);
siteLockspaceApi.interceptors.request.use(attachDirectoryTokenLockspace);

export default siteLockspaceApi;
